import angular from 'angular';
import navbarComponent from './navbar/navbar.component';
import leftnavComponent from './leftnav/leftnav.component';
import usersFilter from './users-filter/users-filter.component';
import profilesFilter from './profiles-filter/profiles-filter.component';
import userBasicDetails from './user-basic-details/user-basic-details.component';
import userAddressDetails from './user-address-details/user-address-details.component';
import userPaymentDetails from './user-payment-details/user-payment-details.component';
import userClientDetails from './user-client-details/user-client-details.component';
import userProviderDetails from './user-provider-details/user-provider-details.component';
import userProfileCompleteness from './user-profile-completeness/user-profile-completeness.component';
import userRatings from './user-ratings/user-ratings.component';
import userTimesheets from './user-timesheets/user-timesheets.component';
import userWalletTransactions from './user-wallet-transactions/user-wallet-transactions.component';
import userChildren from './user-children/user-children.component';
import userVouches from './user-vouches/user-vouches.component';
import userExternalAccounts from './user-external-accounts/user-external-accounts.component';
import userGuardians from './user-guardians/user-guardians.component';
import userJobPreferences from './user-job-preferences/user-job-preferences.component';
import userCertificates from './user-certificates/user-certificates.component';
import mediaFilter from './media-filter/media-filter.component';
import surveyFilter from './survey-filter/survey-filter.component';
import certificatesFilter from './certificates-filter/certificates-filter.component';
import checksFilter from './checks-filter/checks-filter.component';
import jobsFilter from './jobs-filter/jobs-filter.component';
import jobRequestsFilter from './job-requests-filter/job-requests-filter.component';
import affiliatesFilter from './affiliates-filter/affiliates-filter.component';
import vouchesFilter from './vouches-filter/vouches-filter.component';
import userMessages from './user-messages/user-messages.component';
import botManagerFilter from './bot-manager-filter/bot-manager-filter.component';
import userPayAgreements from './user-pay-agreements/user-pay-agreements.component';
import botSessionsFilter from './bot-sessions-filter/bot-sessions-filter.component';
import businessesFilter from './businesses-filter/businesses-filter.component';
import postJob from './post-job/post-job.component';
import userInvoices from './user-invoices/user-invoices.component';
import userJobEdit from './user-job-edit/user-job-edit.component';

let CommonComponents = angular.module('app.common.components', [ ])

.component('navbar', navbarComponent)
.component('leftnav', leftnavComponent)
.component('usersFilter', usersFilter)
.component('profilesFilter', profilesFilter)
.component('userBasicDetails', userBasicDetails)
.component('userAddressDetails', userAddressDetails)
.component('userPaymentDetails', userPaymentDetails)
.component('userClientDetails', userClientDetails)
.component('userProviderDetails', userProviderDetails)
.component('userProfileCompleteness', userProfileCompleteness)
.component('userRatings', userRatings)
.component('userTimesheets', userTimesheets)
.component('userWalletTransactions', userWalletTransactions)
.component('userChildren', userChildren)
.component('userVouches', userVouches)
.component('userExternalAccounts', userExternalAccounts)
.component('userGuardians', userGuardians)
.component('userJobPreferences', userJobPreferences)
.component('userCertificates', userCertificates)
.component('mediaFilter', mediaFilter)
.component('surveyFilter', surveyFilter)
.component('certificatesFilter', certificatesFilter)
.component('checksFilter', checksFilter)
.component('jobsFilter', jobsFilter)
.component('jobRequestsFilter', jobRequestsFilter)
.component('affiliatesFilter', affiliatesFilter)
.component('vouchesFilter', vouchesFilter)
.component('userMessages', userMessages)
.component('botManagerFilter', botManagerFilter)
.component('botSessionsFilter', botSessionsFilter)
.component('businessesFilter', businessesFilter)
.component('postJob', postJob)
.component('userInvoices', userInvoices)
.component('userPayAgreements', userPayAgreements)
.component('userJobEdit', userJobEdit)

export default CommonComponents;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/index.js
 **/